/* eslint-disable camelcase */
import { Vue, Component } from 'vue-property-decorator'
import { ToastUtils } from '@/shared/util/toast-utils'

@Component
export class ToastMixin extends Vue {
    $_showToastSuccess(message: string = this.$tc('component.modalShowSuccess.title'), title: string = '') {
        ToastUtils.showToastSuccess(message, title)
    }
    $_showToastInfo(message: string = this.$tc('component.modalShowInfo.title'), title: string = '') {
        ToastUtils.showToastInfo(message, title)
    }
    $_showToastNotification(message: string = this.$tc('component.modalShowNotification.title'), title: string = '') {
        ToastUtils.showToastNotification(message, title)
    }
    $_showToastAlert(message: string = this.$tc('component.modalShowAlert.title'), title: string = '') {
        ToastUtils.showToastAlert(message, title)
    }
}
